export const Dashboard = () => {
  return (
    <div className="page-container">
      <h1>Dashboard</h1>
    </div>
  )
}
